import * as React from "react";
import type { SVGProps } from "react";
const SvgSmallVayu = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={27}
    height={27}
    fill="none"
    viewBox="0 0 27 27" {...props}
  >
    <g fill="#4AECE0" clipPath="url(#small-vayu_svg__a)">
      <path d="M13.435 11.955c-1.135 0-2.281-.594-2.795-2.208L6.935 0h2.37l3.02 8.322c.538 1.477 1.773 1.477 2.31 0L17.656 0h2.408L16.37 9.668c-.756 1.747-1.748 2.287-2.933 2.287zM13.565 15.046c1.135 0 2.281.593 2.795 2.208L20.065 27h-2.37l-3.02-8.322c-.538-1.477-1.773-1.477-2.31 0l-3.02 8.322h-2.41l3.697-9.668c.756-1.747 1.748-2.287 2.933-2.287M15.047 13.435c0-1.135.593-2.28 2.207-2.795l9.747-3.705v2.37l-8.322 3.02c-1.477.538-1.477 1.773 0 2.31l8.322 3.02v2.41l-9.668-3.697c-1.747-.756-2.286-1.748-2.286-2.933M11.955 13.565c0 1.135-.594 2.281-2.208 2.795L0 20.065v-2.37l8.322-3.02c1.477-.538 1.477-1.773 0-2.31L0 9.344V6.935l9.668 3.697c1.747.755 2.287 1.747 2.287 2.932z" />
    </g>
    <defs>
      <clipPath id="small-vayu_svg__a">
        <path fill="#fff" d="M0 0h27v27H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSmallVayu;
